export default __webpack_public_path__ + "static/media/full1.0bbb74a7.svg";